export default __webpack_public_path__ + "static/media/bnr-hero-855x504-market-data-center.a1d1f2c1.jpg";